import { IFormOfferings } from 'legacy/lut/classes/models/partner360/IFormOfferings'
import { IOfferingChange } from 'legacy/lut/components/widgets/public/partner360/offeringsSwithList/OfferingSwitcher'
import { mapPartner360ProgramTypes } from 'legacy/lut/services/partner360/configuration/mappings/mapPartner360ProgramTypes'
import { useCallback, useMemo } from 'react'
import { useSelector } from 'react-redux'

import { useFormField } from 'cng-common/features/form'

import { selectQBROfferings } from '../../../../../../../../../../../../features/QBR'
import { QBR_SETTINGS_FORM_KEY } from '../../../index'

export const useFormOfferings = (offeringsForCurrentRtm: IFormOfferings[]) => {
  const initialEnabledOfferings = useSelector(selectQBROfferings)

  const {
    handleChange,
    value: enabledOfferings,
    isModified,
  } = useFormField({
    defaultValue: initialEnabledOfferings,
    formKey: QBR_SETTINGS_FORM_KEY,
    field: 'offerings',
  })

  const offerings = useMemo(() => {
    return mapPartner360ProgramTypes(offeringsForCurrentRtm, enabledOfferings)
  }, [offeringsForCurrentRtm, enabledOfferings])

  const onChangeOfferings = useCallback(
    async (changedData: IOfferingChange) => {
      const modifiedOfferings = offerings.map((offering) =>
        offering.programType === changedData.offering.programType
          ? { ...offering, enabled: changedData.flag }
          : offering
      )
      await handleChange(
        modifiedOfferings
          .filter((offering) => offering.enabled)
          .map((offering) => offering.programType)
      )
    },
    [offerings, handleChange]
  )

  return {
    offerings,
    isModified,
    onChangeOfferings,
  }
}
